import { ActionType } from '../infrastructure/actionTypes';

export default (orderCount: number = 0, action: any) => {
  switch (action.type) {
    case ActionType.GET_ORDER_TYPE_COUNT:
      return action.orderCount;
    case ActionType.DECREMENT_ORDER_TYPE_COUNT:
      return Math.max(orderCount - 1, 0);
    default:
      return orderCount;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/adminOrderTypeCount.ts